<template>
	<div class="omapi-rules-list">
		<campaigns-rule-summary-group
			v-for="(group, groupIndex) in ruleset.groups"
			:key="`group-${groupIndex}`"
			:index="groupIndex"
			:group="group"
			v-on="$listeners"
		/>
		<campaigns-rule-summary-item
			v-for="(action, itemIndex) in ruleset.actions"
			:key="`item-${itemIndex}`"
			:index="itemIndex"
			:item="action"
			group-prefix="Then"
			type="action"
			v-on="$listeners"
		>
			<template #groupPrefix>Then</template>
		</campaigns-rule-summary-item>
	</div>
</template>

<script lang="js">
/**
 * Campaign Rules Summary Ruleset
 *
 * @since 2.0.0
 */
export default {
	props: {
		/**
		 * Ruleset object
		 */
		ruleset: {
			type: Object,
			required: true,
		},
		/**
		 * Loop index
		 */
		index: {
			type: Number,
			default: 0,
		},
	},
};
</script>
